import { NgModule } from '@angular/core';
import { PedidosRoutingModule } from './pedidos-routing.module';
import { ErpDetalhesItemComponent } from './modulos/detalhes/components/erp-detalhes-item/erp-detalhes-item.component';

@NgModule({
    imports: [
        PedidosRoutingModule ,
        ErpDetalhesItemComponent     
    ],
    
})
export class PedidosModule { }
